module.exports = __webpack_public_path__ + "media/images/help_icon-dc44d3e307516707698099d8e8caa14a.png";